var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.text)?_c('div',{staticClass:"thanks_wrapper",attrs:{"id":"thanks"}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.value.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }